// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/reviews/reviews';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_card.scss';


$(document).ready(function() {

    $('.card__color-swatches .swatch__option').on('mouseover click', function() {
        let $this = $(this);
        if (!$this.hasClass('selected')) {

            $this.parents('.card--product').find('.swatch__option.selected').removeClass('selected');
            $this.addClass('selected');
            let currentSwatchURL = $this.attr('data-swatch-url'),
                currentSwatchImage1 = $this.attr('data-swatch-image1'),
                currentSwatchImage2 = $this.attr('data-swatch-image2');
            const productCard = $this.parents('.card--product');
            productCard.find('.background-image-1').attr('src', currentSwatchImage1);
            productCard.find('.background-image-2').attr('src', currentSwatchImage2);
            productCard.find('a').attr('href', currentSwatchURL);
        }
    })
})

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--swatches-list").each(function(index, element){
    var $this = $(this);

    // Generate unique class for each feature collection slider
    $this.addClass("swatches-list-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.color-swatches__container--carousel').find(".swiper-button-prev").addClass("swatches-list-btn-prev-" + index);
    $this.parents('.color-swatches__container--carousel').find(".swiper-button-next").addClass("swatches-list-btn-next-" + index);

    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".swatches-list-instance-" + index, {
        // Optional parameters
        modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
        slidesPerView: 4,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
          // when window width is >= 680px
          680: {
            slidesPerView: 6,
          }
        },

        // // Navigation arrows
            navigation: {
            nextEl: ".swatches-list-btn-next-" + index,
            prevEl: ".swatches-list-btn-prev-" + index
        },
    });
  });
  
    //Swiper JS alters the swatches width by adding inline css causing the swatches to have uneven space
    //This function mirrors the first slider width across all caroussels.
    $(window).on('load resize', function () {
        var slider_card = $(".card--product .color-swatches__container--carousel .swiper-slide").not(".color-swatches__container--carousel--desktop-no-arrows");
        var swiper_slide_width = slider_card.width();
        
        $(".page-section--collection .card__swatch-option--no-swiper").width(swiper_slide_width + "px");
        if($(window).width() >= 680){
            $(".color-swatches__container--carousel--desktop-no-arrows .swiper-slide").css("max-width", swiper_slide_width + "px");
        }else {
            $(".color-swatches__container--carousel--desktop-no-arrows .swiper-slide").css("max-width", swiper_slide_width + "px");
            $(".color-swatches__container--carousel--mobile-no-arrows .swiper-slide").css("max-width", swiper_slide_width + "px");
        }
        
    }).resize();;
  
});
